const TemperatureUnit = require("../enums/TemperatureUnit");
const { celsiusToFahrenheit } = require("../utilities/temperatureConversion");
const TemperatureRangeKey = require("../enums/TemperatureRangeKey");
const ImageInfoKey = require("../enums/ImageInfoKey");

/**
 * Generate temperature object
 * @param {Number} celsiusTemp - Celsius temperature
 * @returns {Object} - Temperature object
 */
const generateTemperatureObject = (celsiusTemp) => {
  const fahrenheitTemp = celsiusToFahrenheit(celsiusTemp);
  return {
    [TemperatureUnit.CELSIUS]: celsiusTemp.toFixed(1),
    [TemperatureUnit.FAHRENHEIT]: fahrenheitTemp.toFixed(1),
  };
};

/**
 * Generate delta object
 * @param {Number} markerCelsius - Marker Celsius temperature
 * @param {Number} referenceCelsius - Reference Celsius temperature
 * @returns {Object} - Delta object
 */
const generateDeltaObject = (markerCelsius, referenceCelsius) => {
  const celsiusDelta = markerCelsius - referenceCelsius;

  const markerFahrenheit = celsiusToFahrenheit(markerCelsius);
  const referenceFahrenheit = celsiusToFahrenheit(referenceCelsius);
  const fahrenheitDelta = markerFahrenheit - referenceFahrenheit;

  const sign = celsiusDelta < 0 ? "-" : "+";

  const celsiusDeltaAbs = Math.abs(celsiusDelta);
  const fahrenheitDeltaAbs = Math.abs(fahrenheitDelta);

  return {
    [TemperatureUnit.CELSIUS]: `${sign}${celsiusDeltaAbs.toFixed(1)}`,
    [TemperatureUnit.FAHRENHEIT]: `${sign}${fahrenheitDeltaAbs.toFixed(1)}`,
  };
};

/**
 * Generate temperature range object
 * @param {Number} minCelsius - Minimum Celsius temperature
 * @param {Number} maxCelsius - Maximum Celsius temperature
 * @returns {Object} - Temperature range object
 */
const generateTemperatureRangeObject = (minCelsius, maxCelsius) => {
  const minFahrenheit = celsiusToFahrenheit(minCelsius);
  const maxFahrenheit = celsiusToFahrenheit(maxCelsius);
  return {
    [TemperatureRangeKey.FROM]: {
      [TemperatureUnit.CELSIUS]: minCelsius.toFixed(1),
      [TemperatureUnit.FAHRENHEIT]: minFahrenheit.toFixed(1),
    },
    [TemperatureRangeKey.TO]: {
      [TemperatureUnit.CELSIUS]: maxCelsius.toFixed(1),
      [TemperatureUnit.FAHRENHEIT]: maxFahrenheit.toFixed(1),
    },
  };
};

/**
 * Generate image info object
 * @param {string} name - Name of the info
 * @param {string} type - Type of the info
 * @param {string} value - Value of the info
 * @returns {Object} - Image info object
 */
const generateImageInfoObject = (name, type, value) => {
  return {
    [ImageInfoKey.NAME]: name,
    [ImageInfoKey.TYPE]: type,
    [ImageInfoKey.VALUE]: value,
  };
};

module.exports = {
  generateTemperatureObject,
  generateDeltaObject,
  generateTemperatureRangeObject,
  generateImageInfoObject,
};
